<template>
    <div class="column">
        <slot name="img" />
        <p class="has-text-weight-bold">{{ t(title) }}
        </p>
    </div>
</template>
<script setup>
const { t } = useI18n();
const { title } = defineProps({
    title: String
})
</script>